import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ProgPortalContextService } from 'src/app/core/services/progportalcontextservice';
import { StatusDefinitionIds } from 'src/app/core/enums/statusDefinitionEnums';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { ActionMessages } from 'src/app/core/enums/emailEnums';
import { Router} from '@angular/router';
import { EmailService } from 'src/app/core/services/email/email.service';
import { EmailOptions } from 'src/app/core/services/email/models/email-options.model';
import { CoreRepository } from 'src/app/core/core.repository';
import { AppComponent } from 'src/app/app.component';

export interface StandardProgramDetails {
  programId: number;
  programCode: number;
  shortName: string;
  statusDefinitionId: number;
  productManagerDetails: any[];
  startDate: Date;
  endDate: Date;
}

export interface AdjustAccrualsTargetProgramDetails {
  ProgramCode: number;
  RequestedTotalExposure: number;
}

export interface Messages {
  messageId: number;
  message: string;
  error: boolean;
}

@Component({
  selector: 'app-adjust-accruals',
  templateUrl: './adjust-accruals.component.html',
  styleUrls: ['./adjust-accruals.component.scss']
})

export class AdjustAccrualsComponent implements OnInit, AfterViewInit {
  adjustAccrualsForm: UntypedFormGroup = new UntypedFormGroup({
    TargetProgram: new FormControl(''),
    RequestedTotalExposure: new FormControl('')
  });
  standardProgramDetails: StandardProgramDetails[] = [];
  filteredApprovedStandardProgramDetails: Observable<any[]> = new Observable<any[]>();
  filteredStandardProgramDetails: Observable<any[]> = new Observable<any[]>();
  statusDefinitionIds = StatusDefinitionIds;
  adjustAccrualsTargetProgramDetails: AdjustAccrualsTargetProgramDetails[] = []; 
  targetProgramId: number = 0;
  targetProgramCode: number = 0;
  targetTotalExposure: number = 0;
  requestedTotalExposure: number = 0;
  actionMessages = ActionMessages;
  warningMessages: Messages[] = [];
  isOnlyAssignedProductManagers:boolean = false;
  ids: number[] = [];
  emailOptions = new EmailOptions();
  newMonthsAddedEmailOption = new EmailOptions();
  allAssignedProductManagersEmail: any;
  newMonthsAddedEmail: any;
  isffPickAccrualStatusOnCopy: boolean = false;

  constructor(private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private core: CoreRepository,
    public emailService: EmailService,
    private matSnackBar: MatSnackBar, public context: ProgPortalContextService,
    private app: AppComponent) {
  }
  
  ngOnInit(): void {
    this.adjustAccrualsForm = this.fb.group({
      TargetProgram: ['', Validators.required],
      RequestedTotalExposure: ['', Validators.required]
    });
  }
  get f() { return this.adjustAccrualsForm.controls; }

  ngAfterViewInit() {
    this.binddropdowns();
  }

  private filterStandardProgram(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.standardProgramDetails.filter(standardProgramDetailsOption => standardProgramDetailsOption.shortName.toLowerCase().includes(filterValue) || String(standardProgramDetailsOption.programCode).toLowerCase().includes(filterValue));
  }

  openSuccessSnackBar(message: string, action: string, duration?: number) {
    this.matSnackBar.open(message, action, { duration, panelClass: ['success-snackbar'] });
  }

  openErrorSnackBar(message: string, action: string, duration?: number) {
    this.matSnackBar.open(message, action, { duration, panelClass: ['error-snackbar'] });
  }

  binddropdowns() {    
    this.spinner.show();
    this.context.getdatafromService(`/api/Administration/Table/AccrualAdjustablePrograms`).toPromise().then((response) => {
      if (response != null) {
        this.standardProgramDetails = response;
        this.filteredStandardProgramDetails = this.adjustAccrualsForm.controls.TargetProgram.valueChanges
          .pipe(
            startWith(''),
            map(value => this.filterStandardProgram(value))
          );
      }
      this.spinner.hide();
    });        
  }

  onTargetProgramSelection() {
    
    let selectedTargetProgramDetails = this.standardProgramDetails.filter(x => x.shortName == this.adjustAccrualsForm.controls.TargetProgram.value);
    if (selectedTargetProgramDetails.length > 0) {
      this.targetProgramId = selectedTargetProgramDetails[0].programId;
      this.targetProgramCode = selectedTargetProgramDetails[0].programCode;
      this.getCurrentTotalExposure();
    }
  }

  getCurrentTotalExposure() {
    this.spinner.show();
    this.context.getdatafromService(`/api/Administration/Table/AccrualProgramsTotalExposure/${this.targetProgramCode}`)
    .toPromise().then((response) => {
      if (response !== null) {
        this.targetTotalExposure = response[0].totalExposure;
      }
    },
      msg => { // Error
        this.openErrorSnackBar('Error while getting current total exposure', 'x', 3000);
      })
    .catch(error => this.openErrorSnackBar(error.message, 'x', 3000));
    this.spinner.hide();
  }

  
  adjustAccrualRates() {
    this.spinner.show();
    this.adjustAccrualsTargetProgramDetails = [];
    var requestedTotalExposureValue = this.adjustAccrualsForm.controls.RequestedTotalExposure.value.replace("$", "").replace(/,/g, '');

    this.ids.push(this.targetProgramId);
    const headers = new HttpHeaders().set('content-type', 'application/json');
      this.adjustAccrualsTargetProgramDetails.push({ ProgramCode: this.targetProgramCode, RequestedTotalExposure: requestedTotalExposureValue });
      this.context.postdatatoservice("/api/Administration/Table/AdjustAccrualRates", JSON.stringify(this.adjustAccrualsTargetProgramDetails), headers)
      .toPromise().then((response) => {
        if (response !== null) {
          this.openSuccessSnackBar('Successfully Adjusted Accrual Rates.', 'x', 3000);
          this.spinner.hide();
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl('administration/adjust-accruals');
          });
        }

      },
        msg => { // Error
          this.openErrorSnackBar('Error while Adjusting Accrual Rates', 'x', 3000);
        })
      .catch(error => this.openErrorSnackBar(error.message, 'x', 3000));
      this.spinner.hide();
    }
}


